module.exports = __webpack_public_path__ + "static/img/lunbo.71852e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lunbo.png
// module id = Eu5v
// module chunks = 1